module.exports = __webpack_public_path__ + "static/media/kushner-forbes.0e022af9.jpg";